module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('default-layout', [(_vm.getCourseLoading) ? _c('div', {
    key: "loading",
    staticClass: "text-center mt-10"
  }, [_c('p', {
    staticClass: "mb-2.5"
  }, [_vm._v("Loading Roundtables")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)]) : _c('div', [_c('roundtables-course-table', {
    attrs: {
      "roundtables": _vm.roundtables
    },
    on: {
      "selectedRoundtable": _vm.viewActivity
    }
  })], 1), _vm._v(" "), (_vm.show_choose_activity_overlay) ? _c('FullScreenChooseActivity', {
    attrs: {
      "courseID": _vm.getCourseDetail.id
    },
    on: {
      "close": function($event) {
        _vm.show_choose_activity_overlay = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.integrations_modal === 1) ? _c('integrations-connect-modal', {
    attrs: {
      "logo": _vm.logo,
      "edLink": _vm.edLink,
      "selectedIntegration": _vm.selected_integration
    },
    on: {
      "close": function($event) {
        _vm.show_sync_assessment_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.integrations_modal === 3 && _vm.sync_assessment) ? _c('sync-assessment-data-modal', {
    attrs: {
      "activityType": _vm.activityType,
      "edLink": _vm.edLink,
      "selectedIntegration": _vm.selected_integration,
      "logo": _vm.logo
    },
    on: {
      "close": function($event) {
        _vm.show_sync_assessment_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_integrations_modal) ? _c('connect-integrations-assessment-modal', {
    on: {
      "close": function($event) {
        _vm.show_integrations_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.integrations_modal === 2 ||
    (_vm.integrations_modal === 3 && !_vm.sync_assessment)
  ) ? _c('integrations-assignment-modal', {
    attrs: {
      "logo": _vm.logo,
      "edLink": _vm.edLink,
      "selectedIntegration": _vm.selected_integration,
      "activityType": _vm.activityType
    },
    on: {
      "close": function($event) {
        _vm.show_sync_assessment_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-57bed08b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/courses.vue
// module id = 1021
// module chunks = 61